import type { RouteObject } from "react-router-dom";

import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import ActivosLayout from "./ActivosLayout";
import ActivoDetalleSection from "./sections/ActivoDetalleSection";
import { MENU } from "./config";
import { ActivosIndexRedirect } from "./hooks/useActivosMenu";
import { ACTIVOS_BASE } from "./paths";

// ---------------------------------------------------------------------------
// Rutas de Activos. Archivo común, idéntico en CC-CONSOLE y WAYAK.
//
// El acceso no se decide aquí: `/activos` es la ruta de entrada de
// `app:activos` en el catálogo v26, así que `withEntitlementGates` (App.tsx, en
// los dos forks) la envuelve con su `EntitlementRoute` y, con la bandera `off`
// (D8), manda al Hub. Las secciones las gobiernan sus menús
// (`menu:activos.<id>`): en CC-CONSOLE también por URL (menuEntitlementGuard),
// en los dos ocultándolas del sub-menú. El API niega por su cuenta (chequeo
// duro de `assertActivos`).
// ---------------------------------------------------------------------------

const children: RouteObject[] = [
  { index: true, element: <ActivosIndexRedirect /> },
  ...MENU.map((item) => ({ path: item.id, element: item.element })),
  { path: "inventario/:assetId", element: <ActivoDetalleSection /> },
];

export const activosRoute: RouteObject = {
  path: ACTIVOS_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [{ path: "", element: <ActivosLayout />, children }],
};
